// removed by extract-text-webpack-plugin
module.exports = {"delete":"DeleteButton__delete___2cUdI","trashCan":"DeleteButton__trashCan___1fTUS"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/widgets/DeleteButton/DeleteButton.css
 ** module id = 720
 ** module chunks = 0
 **/